import { Component } from '@grafikr/components';
import Cookie from 'js-cookie';

import Modal from 'utils/components/modal';
import { initCountryPicker } from 'utils/languages';

export default Component((node, { onMounted }) => {
  const modal = new Modal(node);
  const select = node.querySelector<HTMLSelectElement>('[data-select]');
  const form = node.querySelector('form');

  const submitHandler = (event: SubmitEvent) => {
    event.preventDefault();

    const selectedLanguage = window.theme.languages.find(
      (language) => language.country === select.value,
    )!;

    if (selectedLanguage.country === Shopify.country) {
      modal.close();
      return;
    }

    window.location.href = selectedLanguage.domain;
  };

  const setPreferredLanguage = (data) => {
    const fallback = window.theme.languages.find((language) => language.fallback);
    const findMatch =
      window.theme.languages.find((language) => language.country === data.country) ?? fallback;

    if (findMatch) {
      const optionIndex = Array.from(select.options).findIndex(
        (option) => option.value === findMatch.country,
      );
      select.selectedIndex = optionIndex;

      select.dispatchEvent(new Event('change'));
    }
  };

  const buildSelectors = () => {
    initCountryPicker(node, select);
  };

  const initModal = () => {
    buildSelectors();
    form.addEventListener('submit', submitHandler);

    modal.open();
  };

  const init = async () => {
    if (Cookie.get('geo')) {
      return;
    }

    const response = await fetch('https://get.geojs.io/v1/ip/country.json');

    if (response.ok) {
      const data = await response.json();
      Cookie.set('geo', 'true');

      if (data.country !== Shopify.country) {
        initModal();
        setPreferredLanguage(data);
      }
    }
  };

  onMounted(() => {
    init();
  });
});
